<template>
  <div class="page-content">
    <page-template
      ref="orderTemplate"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :detailColumns="detailColumns"
      @searchReset="searchReset"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";
import date from "@/mixin/date";

export default {
  mixins: [userPower, date],
  components: {
    pageTemplate
  },
  data() {
    return {
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "业务单号",
            prop: "orderNo",
            type: "input",
            ifFuzzy: true,
            placeholder: "请输入业务单号"
          }
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24
          },
          // {
          //   label: "采购级别",
          //   type: "select",
          //   prop: "relateType",
          //   data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
          //   change: this.getSelectParam,
          //   span: 12,
          // },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 8,
            isHasAll: true,
            data: [],
            url: api.system.seStore,
            change: this.getSupplier
          },
          {
            label: "仓库名称",
            type: "select",
            prop: "warehouseId",
            span: 8,
            data: []
          },
          {
            label: "供应商",
            type: "select",
            prop: "supplierId",
            data: [],
            span: 8
            // url: api.archives.supplier
          },
          {
            label: "审核状态",
            type: "select",
            prop: "reviewerStatus",
            defaultValue: 20,
            span: 8,
            data: [
              { label: "未审核", value: 20 },
              { label: "已审核", value: 10 }
            ],
            change: this.getStatus
          },
          {
            label: "入库状态",
            type: "select",
            prop: "status",
            span: 8,
            hidden: true
            // data: this.$utils.getCacheStatus("pcPurchaseOrder.status")
          }
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.addRequisition
        },
        // {
        //   label: '打印',
        //   code: 'print',
        // },
        // {
        //   label: '导出',
        //   code: 'export',
        //   callback: this.goodsDetailExport
        // },
        {
          label: "编辑",
          type: this.$utils.buttonType.tableOperate,
          code: "update",
          callback: this.toEditPage,
          filter: data => {
            return data.reviewerStatus == 10 ? false : true;
          }
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
          filter: data => {
            return data.reviewerStatus == 10 ? false : true;
          }
        },
        {
          label: "作废",
          code: "nullify",
          type: this.$utils.buttonType.tableOperate,
          filter: data => {
            if (data.reviewerStatus == 10) {
              //已审核
              return data.status == 10 || data.status == 40 ? false : true; //已入库 已作废 不显示作废
            } else {
              return false;
            }
          },
          callback: this.orderNullify
        }
      ],
      // 表格信息配置
      tableOptions: {
        tableName: "clearTable",
        showSelect: true,
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "业务单号",
            prop: "orderNo",
            width: "240",
            align: "center",
            showDetail: true
          },
          {
            label: "门店仓库",
            prop: "warehouseName",
            width: "120",
            align: "center"
          },
          {
            label: "供应商名称",
            prop: "supplierName",
            width: "190",
            align: "center"
          },
          {
            label: "审核状态",
            prop: "reviewerStatus",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus(
              "pcPurchaseOrder.reviewerStatus"
            )
          },
          {
            label: "单据金额",
            prop: "orderAmt",
            width: "120",
            align: "center"
          },
          // {label: '商品数量', prop: 'goodsNum', width: '120', align: 'center'},
          {
            label: "入库状态",
            prop: "status",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus("pcPurchaseOrder.status")
          },
          {
            label: "制单人",
            prop: "voucherName",
            width: "120",
            align: "center"
          },
          {
            label: "制单日期",
            prop: "voucherDttm",
            width: "150",
            align: "center"
          },
          {
            label: "审核人",
            prop: "reviewerName",
            width: "120",
            align: "center"
          },
          {
            label: "审核日期",
            prop: "reviewerDttm",
            width: "150",
            align: "center"
          },
          { label: "备注", prop: "remarks", width: "125", align: "center" }
        ],
        param: {
          reviewerStatus: 20,
          stCreateDttm: this.getStMonthDate(),
          edCreateDttm: this.getEdMonthDate()
        }
        // url: api.purchase.order
      },
      detailColumns: {
        statusOption: {
          prop: "reviewerStatus",
          statusImg: {
            10: "/static/checked.png",
            20: "/static/un-check.png"
          },
          right: "200px",
          top: "30px"
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: "业务单号",
            prop: "orderNo"
          },
          // {
          //   label: '采购级别',
          //   prop: 'relateType',
          //   enumData: this.$utils.getCacheStatus('pcPurchaseOrder.relateType'),
          //   span: 12,
          // },
          {
            label: "采购门店",
            prop: "storeName"
          },
          {
            label: "供应商",
            prop: "supplierName"
          },
          {
            label: "仓库",
            prop: "warehouseName"
          },
          {
            label: "经手人",
            prop: "handler"
          },
          {
            label: "备注",
            prop: "remarks"
          }
        ],
        tablesProp: {
          pcGoodsMapList: {
            url: api.purchase.goods + "/page",
            height: this.detailHeight,
            tableName: "pcGoodsMapList",
            showSummary: true,
            indexShow: true,
            summaryColumns: ["goodsNum", "giveGoodsNum", "totalPrice"],
            columns: [
              {
                label: "条码",
                prop: "barCode",
                type: "more",
                width: "180",
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: "120",
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: "60",
                align: "center"
              },
              {
                label: "单位",
                width: "60",
                prop: "unitName",
                align: "center"
              },
              {
                label: "自编码",
                width: "120",
                prop: "artNo",
                align: "center"
              },
              // {
              //   label: '档案进价',
              //   prop: 'buyPrice',
              //   align: "center"
              // },
              {
                label: "数量",
                prop: "goodsNum",
                align: "center"
              },
              {
                label: "赠送数量",
                prop: "giveGoodsNum",
                align: "center"
              },
              {
                label: "进价",
                prop: "price",
                align: "center"
              },
              {
                label: "小计金额",
                prop: "totalPrice",
                align: "center"
              },
              {
                label: "零售价",
                prop: "retailPrice",
                align: "center"
              },
              {
                label: "零售金额",
                prop: "salesAmount",
                align: "center"
              },
              {
                label: "系统库存",
                width: "90",
                prop: "inventoryNum",
                align: "center"
              },
              {
                label: "备注",
                prop: "remarks",
                width: "90",
                align: "center"
              }
            ]
          }
        },
        // 打印的列表
        printTablesProp: {
          pcGoodsMapList: {
            tableName: "pcGoodsMapList",
            showSummary: true,
            summaryColumns: ["totalPrice"],
            columns: [
              {
                label: "条码",
                prop: "barCode",
                type: "more",
                width: "180",
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: "120",
                align: "center"
              },
              {
                label: "单位",
                width: "90",
                prop: "unitName",
                align: "center"
              },
              // {
              //   label: '档案进价',
              //   prop: 'buyPrice',
              //   align: "center"
              // },
              {
                label: "数量",
                prop: "goodsNum",
                align: "center"
              },
              {
                label: "赠送数量",
                prop: "giveGoodsNum",
                align: "center"
              },
              {
                label: "进价",
                prop: "price",
                align: "center"
              },
              {
                label: "小计金额",
                prop: "totalPrice",
                align: "center"
              },
              {
                label: "零售价",
                prop: "retailPrice",
                width: "100",
                align: "center"
              },
              {
                label: "零售金额",
                prop: "salesAmount",
                align: "center"
              }
            ]
          }
        },
        url: api.purchase.order
      }
    };
  },
  beforeCreate() {
    this.detailHeight = document.documentElement.clientHeight - 180 - 200;
  },
  created() {
    this.setSupplier(this.searchOptions.complex);
    this.setStore(this.searchOptions.complex);
    let userInfo = this.$utils.getSysUser();
    if (userInfo.storeId) {
      this.getSupplier(userInfo);
    }
    //this.setRelateStoreId(this.searchOptions.complex);
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 0) {
      if (this.$route.params.customQuery) {
        let str = this.$route.params.customQuery;
        this.tableOptions.param = eval("(" + str + ")");
      }
    }
    this.$nextTick(() => {
      this.tableOptions.url = api.purchase.order;
      this.$refs["orderTemplate"].operationSuccess();
    });
  },
  methods: {
    // 搜索重置
    searchReset() {
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.searchOptions.complex.filter(
          item => item.prop === "supplierId"
        )[0].data = [];
      }
    },
    addRequisition() {
      this.$router.push({ path: "/purchase/order/add" });
    },
    toEditPage(row) {
      this.$router.push({ path: "/purchase/order/add?id=" + row.id });
    },
    getSelectParam(form) {
      let storeId = this.searchOptions.complex.filter(
        item => item.prop === "storeId"
      )[0];
      let supplierId = this.searchOptions.complex.filter(
        item => item.prop === "supplierId"
      )[0];
      if (form.relateType === 10) {
        storeId.hidden = true;
        this.$axios
          .fetchPost(api.archives.supplier + "/list", { type: 10 })
          .then(data => {
            if (data.code === 200) {
              supplierId.data = data.data;
            }
          });
      } else {
        //选择门店的时候，查询商户相应的门店
        supplierId.data = [];
        this.clearData();
        storeId.hidden = false;
      }
    },
    // 选择门店
    getSupplier(param) {
      param.supplierId = "";
      param.warehouseId = "";
      let supplierId = this.searchOptions.complex.filter(
        item => item.prop === "supplierId"
      )[0];
      this.$axios
        .fetchPost(api.archives.supplier + "/query/supplier/list", {
          storeId: param.storeId,
          type: 10
        })
        .then(data => {
          if (data.code === 200) {
            supplierId.data = data.data;
          }
        });
      let warehouseId = this.searchOptions.complex.filter(
        item => item.prop === "warehouseId"
      )[0];
      this.$axios
        .fetchPost(api.warehouse.warehouse + "/query/warehouse/list", {
          storeId: param.storeId
        })
        .then(data => {
          if (data.code === 200) {
            warehouseId.data = data.data;
          }
        });
    },
    getStatus(param) {
      let status = this.searchOptions.complex.filter(
        item => item.prop === "status"
      )[0];
      if (param.reviewerStatus !== 20) {
        status.data = this.$utils.getCacheStatus("pcPurchaseOrder.status");
        status.hidden = false;
      } else {
        status.data = [];
        status.hidden = true;
      }
    },
    clearData() {
      this.$nextTick(() => {
        console.log("--->" + this.$refs.orderTemplate);
      });
    },
    goodsDetailExport() {
      let selectData = this.$refs["orderTemplate"].$refs["tableTemp"].selectRow;
      if (selectData.length === 0) {
        this.$confirm("请选择一条数据！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } else {
        if (selectData.length > 1) {
          this.$confirm("只能选择一条数据！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$refs["orderTemplate"].$refs["tableTemp"].$refs[
              "clearTable"
            ].clearSelection();
          });
        } else {
          this.$axios
            .fetchPost(api.purchase.orderExport, {
              orderNo: selectData[0].orderNo,
              exportCode: "PcPurchaseOrderExport"
            })
            .then(data => {
              if (data.code === 200) {
                const elink = document.createElement("a");
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: "导出操作",
                  message: "成功",
                  showClose: false
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: "导出操作",
                  message: "失败",
                  showClose: false
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            });
        }
      }
    },
    orderNullify(form) {
      form.status = 40;
      //订单作废
      this.$axios.fetchPut(api.purchase.order, form).then(data => {
        if (data.code === 200) {
          this.$refs["orderTemplate"].operationSuccess();
          this.$notify({
            type: "success",
            title: "作废操作",
            message: "成功",
            showClose: false
          });
          // this.$message({message: '操作成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: "作废操作",
            message: "失败",
            showClose: false
          });
          // this.$message({message: '操作异常', type: 'error'});
        }
      });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/purchase/Order.vue